import * as React from "react";
const SvgLabel = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ...props
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_4418_9378)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M20.957 4.55504L12.986 0.126041C12.8374 0.043381 12.6701 0 12.5 0C12.3299 0 12.1626 0.043381 12.014 0.126041L4.043 4.55504C3.5754 4.81483 3.18578 5.19492 2.91448 5.65594C2.64318 6.11695 2.50008 6.64212 2.5 7.17704V19C2.50159 20.3256 3.02888 21.5965 3.96622 22.5338C4.90356 23.4712 6.17441 23.9985 7.5 24H17.5C18.8256 23.9985 20.0964 23.4712 21.0338 22.5338C21.9711 21.5965 22.4984 20.3256 22.5 19V7.17704C22.4999 6.64212 22.3568 6.11695 22.0855 5.65594C21.8142 5.19492 21.4246 4.81483 20.957 4.55504ZM20.5 19C20.5 19.7957 20.1839 20.5588 19.6213 21.1214C19.0587 21.684 18.2956 22 17.5 22H7.5C6.70435 22 5.94129 21.684 5.37868 21.1214C4.81607 20.5588 4.5 19.7957 4.5 19V7.17704C4.49956 6.99816 4.5471 6.82243 4.63768 6.66818C4.72827 6.51393 4.85856 6.3868 5.015 6.30004L12.5 2.14404L19.986 6.30004C20.1422 6.38693 20.2723 6.51412 20.3627 6.66836C20.4531 6.8226 20.5005 6.99826 20.5 7.17704V19Z",
      fill: "#1B1C1D"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12.5 8.50049C13.3284 8.50049 14 7.82892 14 7.00049C14 6.17206 13.3284 5.50049 12.5 5.50049C11.6716 5.50049 11 6.17206 11 7.00049C11 7.82892 11.6716 8.50049 12.5 8.50049Z",
      fill: "#1B1C1D"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_4418_9378" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white", transform: "translate(0.5)" })))
);
export default SvgLabel;
